import type { TextInputValue } from 'suomifi-ui-components'
import { MaritalStatus } from 'todistukset-common/src/vtj/MaritalStatus.enum'
import type { CountryKoodistoCode } from 'todistukset-common/src/vtj/vtj-koodisto.util'
import {
  editIlmoitettuArvo,
  finalEditableFieldValue,
} from 'todistukset-common/src/vtj/types/editable-field.type'
import type {
  AetOrdererUiForm,
  AetSignerUiForm,
} from 'todistukset-common/src/vtj/types/form-types.type'

type Form = AetOrdererUiForm | AetSignerUiForm

type SingleSelectValue<T> = { uniqueItemId: T } | null

const setCountryOfResidence = (
  form: Form,
  value: SingleSelectValue<CountryKoodistoCode>
): void => {
  form.orderer.countryOfResidenceCode = editIlmoitettuArvo(
    form.orderer.countryOfResidenceCode,
    value?.uniqueItemId ?? null
  )
}

const setNumberOfMarriages = (
  form: Form,
  value: SingleSelectValue<string>
): void => {
  const numberOfMarriages = Number(value?.uniqueItemId)
  form.orderer.numberOfMarriages = editIlmoitettuArvo(
    form.orderer.numberOfMarriages,
    !isNaN(numberOfMarriages) && Number.isInteger(numberOfMarriages)
      ? numberOfMarriages
      : form.orderer.numberOfMarriages?.vtjArvo ?? null
  )

  form.orderer.maritalStatus = editIlmoitettuArvo(
    form.orderer.maritalStatus,
    finalEditableFieldValue(form.orderer.maritalStatus)
  )
}

const setMaritalStatus = (
  form: Form,
  value: SingleSelectValue<MaritalStatus>
): void => {
  form.orderer.maritalStatus = editIlmoitettuArvo(
    form.orderer.maritalStatus,
    value?.uniqueItemId ?? form.orderer.maritalStatus?.vtjArvo ?? null
  )
  if (
    finalEditableFieldValue(form.orderer.maritalStatus) ===
      MaritalStatus.NAIMATON ||
    form.orderer.maritalStatus === null
  ) {
    form.orderer.numberOfMarriages = editIlmoitettuArvo(
      form.orderer.numberOfMarriages,
      null
    )
  } else {
    form.orderer.numberOfMarriages = editIlmoitettuArvo(
      form.orderer.numberOfMarriages,
      finalEditableFieldValue(form.orderer.numberOfMarriages)
    )
  }
}

const setSukulaisuussuhdeVakuutettu = (
  form: Form,
  value: { checkboxState: boolean }
): void => {
  form.sukulaisuussuhdeVakuutettu = editIlmoitettuArvo(
    form.sukulaisuussuhdeVakuutettu,
    value.checkboxState
  )
}

const setContactPhone = (form: Form, value: TextInputValue): void => {
  form.contactInfo.phoneNumber = editIlmoitettuArvo(
    form.contactInfo.phoneNumber,
    !value ? '' : String(value)
  )
}

const setContactEmail = (form: Form, value: TextInputValue): void => {
  form.contactInfo.email = editIlmoitettuArvo(
    form.contactInfo.email,
    !value ? '' : String(value)
  )
}

export default {
  setCountryOfResidence,
  setNumberOfMarriages,
  setMaritalStatus,
  setSukulaisuussuhdeVakuutettu,
  setContactPhone,
  setContactEmail,
}
